import React from 'react'
import PropTypes from 'prop-types'
import { userPropTypes } from '../../../prop-types'
import Row from '../../common/Row'
import PodiumPosition from '../PodiumPosition'

const Podium = ({
    winners,
    me,
}) => {
    const sortedWinners = [{
        user: winners[1],
        position: 2,
    }, {
        user: winners[0],
        position: 1,
    }, {
        user: winners[2],
        position: 3,
    }]

    return (
        <Row alignItems="flex-end">
            {sortedWinners.map(({ user, position }) => (
                <PodiumPosition
                    key={user.id}
                    user={user}
                    position={position}
                    isMe={me != null && me.id === user.id}
                />
            ))}
        </Row>
    )
}

Podium.propTypes = {
    winners: PropTypes.arrayOf(userPropTypes),
    me: userPropTypes,
}

Podium.defaultProps = {
    winners: [],
    me: null,
}
export default Podium
